import BaseFeature from '../../foundation/base/base';
import { debounce } from '../../foundation/utilities/debounce';

export default class LazyLoad extends BaseFeature {
	constructor(element) {
		super(element);

		this.elm = element;
		this.lazyload();

		this.debouncedHandleResize = debounce(() => {
			this.handleResize();
		}, 250);

		window.addEventListener('resize', this.debouncedHandleResize);
	}

	lazyload() {
		// If useragent doens't support scroll, then it is probably a Google Bot
		// Therefore all images should be rendered for SEO purposes
		const supportScroll = ('onscroll' in window) && !(/glebot/.test(navigator.userAgent));

		// If the useragent doesn't support IntersectionObserver, we need to render all images
		const supportIntersectionObserver = 'IntersectionObserver' in window;

		if (supportScroll && supportIntersectionObserver) {
			this.observe();
		} else {
			this.reveal();
		}
	}

	observe() {
		const observerOptions = {
			// Offset the IntersectionObserver by 20%
			rootMargin: '20%'
		};

		this.observer = new IntersectionObserver(this.handleIntersect.bind(this), observerOptions);
		this.observer.observe(this.elm);
	}

	handleIntersect(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				this.reveal();
				observer.disconnect();
			}
		});
	}

	handleResize() {
		this.calculateSize();
	}

	calculateSize() {
		const width = Math.round(this.dom.img.offsetWidth / document.documentElement.clientWidth * 100);
		this.dom.img.setAttribute('sizes', `(max-width: 768px) 100vw, ${width}vw`);
		this.dom.src.setAttribute('sizes', `(max-width: 768px) 100vw, ${width}vw`);
	}

	reveal() {
		this.calculateSize();

		this.dom.img.onload = () => {
			this.element.classList.add('is-loaded');
		};

		this.dom.src.setAttribute('srcset', this.dom.src.getAttribute('data-srcset'));
		this.dom.img.setAttribute('srcset', this.dom.img.getAttribute('data-srcset'));
		this.dom.img.setAttribute('src', this.dom.img.getAttribute('data-src'));
	}
}
